import ThickLine from './ThickLine'

declare const __CLIENT__: boolean
const L = __CLIENT__ ? await import('leaflet') : null

L.SVG.include({
  _updateShape: function _updateShape(layer) {
    this._setPath(layer, layer._pathd)
  }
})

L.thickLine = L.Path.extend({
  options: {
    fill: true,
    radius: 100
  },

  initialize: function (points, options) {
    L.setOptions(this, options)
    this._points = points
    this._radius = this.options.radius
  },

  setPoints: function (points) {
    this._points = points
    return this.redraw()
  },

  getPoints: function () {
    return this._points
  },

  setRadius: function (radius) {
    this.options.radius = this._radius = radius
    return this.redraw()
  },

  getRadius: function () {
    return this._radius
  },

  setStyle: function (options) {
    const radius = (options && options.radius) || this._radius
    L.Path.prototype.setStyle.call(this, options)
    this.setRadius(radius)
    return this
  },

  _project: function () {
    const map = this._map
    const mapPoints = this._points.map((p) => {
      const { x, y } = map.project([p[0], p[1]]).subtract(map.getPixelOrigin())
      return [x, y]
    })
    const p = this._points[0]
    const pp = map.project([p[0], p[1]])
    const pp2 = map.project([
      p[0] + ((this._radius / 6371000) * 180) / Math.PI,
      p[1]
    ])
    const r = pp.subtract(pp2).y
    this._pathd = ThickLine(mapPoints, r)
    this._updateBounds()
  },

  _updateBounds: function () {
    /*
		var r = this._radius,
			r2 = this._radiusY || r,
			w = this._clickTolerance(),
			p = [r + w, r2 + w]
    this._pxBounds = new L.Bounds(this._point.subtract(p), this._point.add(p))
    */
  },

  _update: function () {
    if (this._map) {
      this._updatePath()
    }
  },

  _updatePath: function () {
    this._renderer._updateShape(this)
  },

  _empty: function () {
    return this._size && !this._renderer._bounds.intersects(this._pxBounds)
  }
})

export default L.thickLine
